'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _resolve = require('./resolve');

var _resolve2 = _interopRequireDefault(_resolve);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Extension = function Extension(Bridge) {
  return {
    normal: function normal(alias, rules) {
      return _underscore2.default.assign(Bridge.prototype, _defineProperty({}, alias, function (view, options) {
        return _resolve2.default.call(this, rules[view]).then(function (hander) {
          return hander(options);
        });
      }));
    },
    // deprecated
    info: function info() {},
    listen: function listen(rule) {
      return _underscore2.default.assign(Bridge.prototype, {
        listen: function listen(func) {
          return _resolve2.default.call(this, rule).then(function (hander) {
            return hander(func);
          });
        }
      });
    }
  };
};

exports.default = Extension;